<template>
    <b-overlay :show="getting || typeLoading" opacity="0.2">
        <b-sidebar v-model="showDrawer" right shadow="" bg-variant="white" backdrop>
            <daily-score-detail v-model="currentData" v-on:excuse-end="excuseEnd" v-on:refresh="getDaily"></daily-score-detail>
        </b-sidebar>

        <b-card no-body class="daily-card">
            <!-- <div class="p-50">
                <v-date-picker v-model="date" v-on:input="getDaily"></v-date-picker>
            </div> -->
            <div class="bg-light rounded m-1 p-1">
                <div class="col">
                    <h5>{{today}}</h5>
                    <h3 class="font-weight-bolder text-dark mb-0">{{$safe(dailyData,'GaragesOrBranches') || '---'}}</h3>
                </div>
            </div>
            <div class="px-1 mb-1">
                <vue-perfect-scrollbar>
                    <div class="d-flex g-25 w-100" >
                        <div v-for="(type,index) in types" :key="index" class="type d-flex align-items-center py-25 pl-25 pr-50 text-nowrap" :class="`type-bg-${type.Color}`">
                            <div class="d-flex align-items-center justify-content-center font-weight-bolder mr-50" :class="`type-${type.Color}`">{{type.Code}}</div>
                            {{$safe(type,'Name')}}
                        </div>
                    </div>
                </vue-perfect-scrollbar>
            </div>
            <div v-if="($safe(dailyData,'Data') || []).length" class="row justify-content-between mx-50">
                <div class="col-md-3 mb-75">
                    <select class="form-control" v-model="branch">
                        <option :value="null">Tümü</option>
                        <option v-for="(b,i) in branches" :value="b.BranchId">{{ b.BranchName }}</option>
                    </select>
                </div>
                <div class="col-md-3 mb-75">
                    <b-input-group class="input-group-merge">
                        <template #prepend>
                            <b-input-group-text >
                                <feather-icon icon="SearchIcon"></feather-icon>
                            </b-input-group-text>
                        </template>
                        <b-form-input v-model="searchValue" placeholder="Ara..." ></b-form-input>
                    </b-input-group>
                </div>
            </div>
            <div class="px-1 border-bottom">
                <div class="row">
                    <div class="col-auto mb-75">
                        <button :disabled="!hasAnyUnsavedH" v-on:click="convertAllTo('854e3e88-7195-4d6f-ad87-fe66e6171e80')" class="btn btn-xs btn-outline-secondary">Tüm Kaydedilmemiş Hafta Tatillerini Normale Çevir</button>
                    </div>
                    <div class="col-auto mb-75">
                        <button :disabled="!hasAnyUnsavedRT" v-on:click="convertAllTo('3135f805-3954-428c-953b-78e8187a752c')" class="btn btn-xs btn-outline-secondary">Tüm Kaydedilmemiş Resmi Tatillerini Normale Çevir</button>
                    </div>
                </div>
            </div>
            <div class="table-responsive end" v-if="($safe(dailyData,'Data') || []).length">
                <table class="table table-sm table-bordered align-middle">
                    <thead>
                        <tr>
                            <th rowspan="2" colspan="2"></th>
                            <th class="align-middle column-sticky" rowspan="2">Personel</th>
                            <th class="align-middle" rowspan="2">Garaj</th>
                            <th class="align-middle text-nowrap text-center" rowspan="2" v-b-tooltip.noninteractive.hover.bottom title="Organizasyonel Konum">OK</th>
                            <th class="align-middle" rowspan="2" v-b-tooltip.noninteractive.hover.bottom title="Kalan Yıllık İzin Hakkı">KYİH</th>
                            <template v-for="(v,k) in dates.GroupByMonth">
                                <th :colspan="(v || []).length" :key="k">{{k}}</th>
                            </template>
                        </tr>
                        <tr class="sticky-date">
                            <template v-for="(v,k) in dates.GroupByMonth">
                                <template v-for="(d,i) in v" >
                                    <th class="text-center" :key="k+i">
                                        {{d.Day}}<br/><span class="text-muted">{{d.DayName}}</span>
                                        </th>
                                </template>
                            </template>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(ds,di) in datas">
                            <tr :key="di">
                                <td class="text-center font-weight-bolder">{{(di + 1)}}</td>
                                <td>
                                    <div class="d-flex">
                                        <button class="btn btn-outline-secondary btn-sm" v-on:click="openDrawer(ds)">Detay</button>
                                        <div v-b-tooltip.noninteractive.hover.bottomright :title="canMultiUpdate(ds) ? `${$safe(ds,'EmployeeFullName')} adlı personelin günlük puantajlarını kaydet.` : `${$safe(ds,'EmployeeFullName')} adlı personelin tüm puantajı kaydedilmiştir.`">
                                            <button :disabled="!canMultiUpdate(ds) || multipleSaving" v-on:click="saveMultiple(ds)" class="btn btn-outline-primary btn-sm text-nowrap ml-25">Kaydet</button>
                                        </div>
                                    </div>
                                </td>
                                <td class="text-nowrap column-sticky">{{$safe(ds,'EmployeeFullName') || '-'}}</td>
                                <td>
                                    <daily-score-garage-detail 
                                    v-if="($safe(ds,'Garages') || []).length"
                                    :garages="$safe(ds,'Garages') || []"
                                    :k="di"/>
                                    <template v-else>-</template>
                                </td>
                                <td>
                                    <daily-score-collar-status-detail
                                    :collars="$safe(ds,'CollarStatuses') || []"
                                    :k="di"
                                    />
                                </td>
                                <td>{{$safe(ds,'RemainingAnnualHolidayRight') || 0}}</td>
                                <template v-for="(d,i) in dates.Days">
                                    <daily-score-day-cell 
                                    :key="`${di}-${i}-${ds.EmployeeFullName}`"
                                    :loading="currentCell == `${di}-${i}`"
                                    v-model="ds['Days'][d.Key]"
                                    :all-types="types"
                                    :types-without-excuse="typesWithoutExcuse"
                                    :on-multiple="multipleSaving"
                                    v-on:change="event => onChange(d,ds,event,`${di}-${i}`)" />
                                </template>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
            <div class="text-right pb-1 px-1" v-if="($safe(dailyData,'Data') || []).length">
                <button class="btn btn-danger" :disabled="multipleSaving" v-on:click="saveTotal">
                    Tümünü Kaydet
                </button>
            </div>
        </b-card>
    </b-overlay>
</template>

<script>
import { BCard, BOverlay, VBTooltip, BSidebar, BInputGroup, BInputGroupText, BFormInput } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations' 
import moment from 'moment'
import DailyScoreDayCell from './components/DailyScoreDayCell.vue'
import DailyScoreGarageDetail from './components/DailyScoreGarageDetail.vue'
import DailyScoreCollarStatusDetail from './components/DailyScoreCollarStatusDetail.vue'
import DailyScoreDetail from './components/DailyScoreDetail.vue'
import additional from '@/utilities/additional'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    components:{
        BCard,
        BOverlay,
        BSidebar,
        DailyScoreDayCell,
        DailyScoreGarageDetail,
        DailyScoreCollarStatusDetail,
        DailyScoreDetail,
        BInputGroup, 
        BInputGroupText, 
        BFormInput,
        VuePerfectScrollbar
    },
    directives:{
        'b-tooltip':VBTooltip
    },
    data(){
        return {
            date:moment().format('YYYY-MM-DD'),
            today:moment().locale('tr').format('DD MMMM YYYY'),
            getting:false,
            types:[],
            typesWithoutExcuse:[],
            typeLoading:false,
            dailyData:{},
            currentCell:null,
            showDrawer:false,
            currentData:null,
            multipleSaving:false,
            searchValue:"",
            branch:null,
        }
    },
    mounted(){
        this.getDaily()
        this.getWorkingTypes()
        this.getWorkingTypeWithoutExcuses()
    },
    methods:{
        getDaily(){
            this.getting = true
            EmployeeOperationsApi.Score.ListByDate(this.date).then(res=>{
                this.getting = false
                if(res.data.Success){
                    this.dailyData = res.data.Data
                }else{
                    this.$result(res)
                }
            }).catch(err=>{
                this.getting = false
                this.$result(null,err)
            })
        },
        groupBy(xs, key){
            return xs.reduce(function(rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        },
        getWorkingTypes(){
            this.typeLoading = true
            EmployeeOperationsApi.Score.WorkingType().then(res=>{
                this.typeLoading = false
                this.types = res.data.Data
            }).catch(err=>{ this.typeLoading = false })
        },
        getWorkingTypeWithoutExcuses(){
            EmployeeOperationsApi.Score.WorkingTypeExcuseFilter(false).then(res=>{
                this.typesWithoutExcuse = res.data.Data || []
            })
        },
        onChange(d,ds,ewtId,cc){
            try {
                if((this.$safe(this.dailyData,'Data') || []).length > 0){
                    const exist = this.dailyData.Data.find(d => d.IdentityNumber == ds.IdentityNumber)
                    if(exist){
                        var day = exist.Days[d.Key]
                        if(day){
                            this.$set(day,'Saved',false)
                            this.$set(day,'EmployeeWorkingTypeId',ewtId)
                        }
                    }
                }
            } catch (error) {
                console.log(error)
            }
            
            // this.currentCell = cc
            // EmployeeOperationsApi.Score.CreateOrUpdateDailyScore({
            //     Days:[{
            //         EmployeeId:ds.EmployeeId || null,
            //         Date:moment(d.Key,'DD.MM.YYYY').format('YYYY-MM-DD'),
            //         EmployeeWorkingTypeId:ewtId,
            //         BranchId:this.$safe(ds,'Days')?.[d.Key]?.BranchDetail?.BranchId
            //     }]
            // }).then(res=>{
            //     this.$result(res)
            //     this.currentCell = null
            //     if(res.data.Success){
            //         // try {     
            //         //     if(Array.isArray(res.data.Data) && res.data.Data[0]){
            //         //         const data = res.data.Data[0].Data[0]
            //         //         if(data){
            //         //             const exist = this.dailyData.Data.find(d => d.IdentityNumber == data.IdentityNumber)
            //         //             if(exist){
            //         //                 this.$set(exist,'Days',data.Days)
            //         //             }
            //         //         }
            //         //     }
            //         // } catch (error) {
            //         //     console.log(error)
            //         // }
            //         this.getDaily()
            //     }
            // }).catch(err=>{
            //     this.$result(null,err)
            //     this.currentCell = null
            // })
        },
        openDrawer(ds){
            this.currentData = null
            this.currentData = ds
            this.$nextTick(()=>{
                this.showDrawer = true
            })
        },
        canMultiUpdate(ds){
            return Object.entries(ds.Days).map(([key,value]) => ({
                Day:key,
                Editable:value.Editable,
                EmployeeWorkingTypeId:value.EmployeeWorkingTypeId,
                Working: value.Working,
                Saved: value.Saved
            })).filter(d => d.Editable && !d.Saved && d.Working).length > 0
        },
        saveMultiple(ds){
            this.multipleSaving = true 
            EmployeeOperationsApi.Score.CreateOrUpdateDailyScore({
                    Days:
                        Object.entries(ds.Days).map(([key,value]) => ({
                            EmployeeId:ds.EmployeeId,
                            Date: moment(key,'DD.MM.YYYY').format('YYYY-MM-DD'),
                            EmployeeWorkingTypeId:value.EmployeeWorkingTypeId,
                            Editable:value.Editable,
                            Saved: value.Saved,
                            Working: value.Working,
                            BranchId:value.BranchDetail?.BranchId || null,
                        })).filter(d => d.Editable && d.Working && !d.Saved),
                }).then(res=>{
                this.$result(res)
                this.multipleSaving = false
                if(res.data.Success){
                    this.getDaily()
                }
            }).catch(err=>{
                this.$result(null,err)
                this.multipleSaving = false
            })
        },
        excuseEnd(){
            this.$nextTick(()=>{
                this.showDrawer = false
            })
            this.getDaily()
        },
        saveTotal(){
            this.$confirm('Toplu kaydetmek istediğinize emin misiniz?','Bu işlem çalışan personelin düzenlenebilir günlerindeki kaydedilmemiş olan otomatik atanmış günlük puantajını kaydeder.').then(res=>{
                if(res){
                    this.multipleSaving = true 
                    EmployeeOperationsApi.Score.CreateOrUpdateDailyScore({
                        Days:
                            this.datas.reduce((arr,ds) => {
                                arr.push(...Object.entries(ds.Days).map(([key,value]) => ({
                                    EmployeeId:ds.EmployeeId,
                                    Date: moment(key,'DD.MM.YYYY').format('YYYY-MM-DD'),
                                    EmployeeWorkingTypeId:value.EmployeeWorkingTypeId,
                                    Editable:value.Editable,
                                    Saved: value.Saved,
                                    Working: value.Working,
                                    BranchId:value.BranchDetail?.BranchId || null,
                                })).filter(d => d.Editable && d.Working && !d.Saved))
                                return arr
                            },[])
                        }).then(res=>{
                        this.$result(res)
                        this.multipleSaving = false
                        if(res.data.Success){
                            this.getDaily()
                        }
                    }).catch(err=>{
                        this.$result(null,err)
                        this.multipleSaving = false
                    })
                }
            })
        },
        convertAllTo(typeId){
            const type = typeId == '854e3e88-7195-4d6f-ad87-fe66e6171e80' ? 'H' : 'RT'
            this.$confirm('Değiştirmek isteidğinize emin misiniz?',`Bu işlem tüm ${type == 'H' ? 'hafta tatillerini (H)' : 'resmi tatilleri (RT)'} normale (N) dönüştürücektir.`).then(r => {
                if(r){
                    (this.$safe(this.dailyData,'Data') ||[]).forEach(element => {
                        Object.values(element.Days).filter(s => s.EmployeeWorkingTypeId == typeId && s.Saved == false && s.Working == true && s.Locked == false).forEach(t => {
                            this.$set(t,'EmployeeWorkingTypeId','55fd850b-530a-4849-9bb4-804fddd490e1')
                        })
                    });
                }
            })
        },
    },
    computed:{
        dates(){
            if(this.dailyData?.Data?.[0]?.Days){
                const days = Object.entries(this.dailyData.Data[0].Days).map(([key,value])=>({
                    Month:moment(key,'DD.MM.YYYY').locale('tr').format('MMMM YYYY'),
                    Day:moment(key,'DD.MM.YYYY').format('DD'),
                    DayName:moment(key,'DD.MM.YYYY').locale('tr').format('ddd'),
                    Key:key
                })).reverse()
                return {
                    Days:days,
                    GroupByMonth:this.groupBy(days,'Month')
                }
            }else return {Days:[],GroupByMonth:{}}
        },
        datas(){
            if(this.dailyData && this.dailyData.Data){
                return this.dailyData.Data
                    .filter(d => additional.ToEng(d.EmployeeFullName).toLowerCase().includes(additional.ToEng(this.searchValue).toLowerCase()))
                    .filter(d => this.branch != null ? d.Garages.some(g => g.BranchId == this.branch) : true)
            } else return []
        },
        branches(){
            if(this.dailyData && this.dailyData.GarageOrBranchesDetailed){
                return [...new Map(this.dailyData.GarageOrBranchesDetailed.map(item => [item['BranchId'], item])).values()]
            } else return []
        },
        hasAnyUnsavedH(){
            return (this.$safe(this.dailyData,'Data') ||[]).some(s => {
                const has = Object.entries(s.Days).filter(([key,val]) => {
                    const has = val.EmployeeWorkingTypeId == "854e3e88-7195-4d6f-ad87-fe66e6171e80" && val.Saved == false && val.Working == true
                    has && console.log(s.EmployeeFullName,key,val)
                    return has
                })
                if(has){
                    console.log(s)
                    console.log(Object.values(s.Days).filter(s => s.EmployeeWorkingTypeId == "854e3e88-7195-4d6f-ad87-fe66e6171e80" && s.Saved == false && s.Working == true))
                }
                return Object.values(s.Days).some(s => s.EmployeeWorkingTypeId == "854e3e88-7195-4d6f-ad87-fe66e6171e80" && s.Saved == false && s.Working == true && s.Locked == false)
            })
        },
        hasAnyUnsavedRT(){
            return (this.$safe(this.dailyData,'Data') ||[]).some(s => {
                return Object.values(s.Days).some(s => s.EmployeeWorkingTypeId == "3135f805-3954-428c-953b-78e8187a752c" && s.Saved == false && s.Working == true && s.Locked == false)
            })
        }
    }
}
</script>

<style lang="scss">
@use "sass:map";

$types-bg:(
    'indigo': #8888ca,
    'pink': #a17191,
    'green': #83974a,
    'purple': #9a779b,
    'light-orange': #c1aca8,
    'dark-green': #9a997e,
    'yellow': #c7bf41,
    'red': #bc797e,
    'clean': #ffffff,
    'orange': #a87a4e,
    'teal': #8cbde5,
    'blue': #46b5d4,
    'gray': #9ea3c0,
);

$types-color:(
    'indigo': hsl(240, 38%, 33%),
    'pink': hsl(320, 20%, 21%),
    'green': hsl(76, 34%, 11%),
    'purple': hsl(298, 15%, 21%),
    'light-orange': hsl(10, 17%, 38%),
    'dark-green': hsl(58, 12%, 21%),
    'yellow': hsl(56, 54%, 19%),
    'red': hsl(356, 33%, 28%),
    'clean': hsl(0, 0%, 0%),
    'orange': hsl(29, 37%, 15%),
    'teal': hsl(207, 63%, 38%),
    'blue': hsl(193, 62%, 22%),
    'gray': hsl(231, 21%, 36%),
);

$types-bg-color:(
    'indigo': hsl(240, 38%, 65%),
    'pink': hsl(320, 20%, 53%),
    'green': hsl(76, 34%, 43%),
    'purple': hsl(298, 15%, 53%),
    'light-orange': hsl(10, 17%, 60%),
    'dark-green': hsl(58, 12%, 53%),
    'yellow': hsl(56, 54%, 51%),
    'red': hsl(356, 33%, 60%),
    'clean': hsl(0, 0%, 62%),
    'orange': hsl(29, 37%, 55%),
    'teal': hsl(207, 63%, 65%),
    'blue': hsl(193, 62%, 60%),
    'gray': hsl(231, 21%, 63%),
);


@each $class,$color in $types-bg{
    .type-#{$class}{
        background-color: $color !important;
        color: map.get($types-color,$class) !important;

        & .daily-select{
            border-color: darken(map.get($types-bg-color,$class), 10%);
        }
    }
    .type-bg-#{$class}{
        background-color: lighten(map.get($types-bg-color,$class), 32%);
        color: map.get($types-color,$class) !important;
    }
};

.type{
    border-radius: 0.75rem;
    font-size: 0.9rem;
}

.type > div{
    height: 24px;
    font-size: 0.85rem;
    border-radius: 0.5rem;
    padding: 0 0.25rem;
    min-width: 24px;
}

.column-sticky{
    position: sticky;
    left: 0px;
    box-shadow: inset -1px 0px 0px 0px #d4d2de;
    z-index: 1;
}

.column-sticky:not(th){
    background-color: white;
}

.dark-layout .column-sticky:not(th){
    background-color: #283046 !important;
}

.dark-layout .column-sticky{
    box-shadow: inset -1px 0px 0px 0px rgb(75, 82, 103) !important;
}

.grid-type{
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(min(200px, 100%), 1fr));
}

.daily-card{
    max-height: calc(100dvh - 170px);
}
.sticky-date{
    position: sticky;
    top: -1px;
    z-index: 5;
}
</style>